import { useTranslation } from 'react-i18next'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import LayoutContent from '@/components/LayoutContent'

const NotFoundPage = () => {
  const { t } = useTranslation()
  return (
    <LayoutContent>
      <Typography variant="h1">{t('page_not_found')}</Typography>
      <Stack spacing={2} sx={{
        width: "100%"
      }}>
        <Alert severity="warning">
          <AlertTitle>{t('404_not_found')}</AlertTitle>
          {t('this_page')} — <strong>{t('doesnt_exist')}</strong>
        </Alert>
      </Stack>
    </LayoutContent>
  );
}

export default NotFoundPage
